import template from './editCustomers.html';
import controller from './editCustomers.controller';
import metaData from '../../models/metaData.js';

let editCustomersComponent = () => {
  return {
    restrict: 'E',
    bindings: {},
    template,
    controller,
    controllerAs: 'vm',
    link: ($scope) => {
      setDefaults($scope);
    }
  };
};

function setDefaults($scope) {
  $scope.vm.metaData = {};
  angular.copy(metaData, $scope.vm.metaData);

  $scope.vm.metaData.customers.search.value = $scope.vm.searchValue;
}

export default editCustomersComponent;


// WEBPACK FOOTER //
// ./app/components/editCustomers/editCustomers.component.js